import * as Types from '../../../types/generated';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetHirerAccountsQueryVariables = Types.Exact<{
  returnUri: Types.Scalars['String']['input'];
}>;

export type GetHirerAccountsQuery = {
  hirerAccounts: {
    totalCount: number;
    edges: Array<{
      node: {
        id: string;
        businessName: string;
        hasConnectedTalentSearchAccess: boolean;
        loginRedirectUrl: string;
      };
    }>;
  };
};

export const GetHirerAccountsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetHirerAccounts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'returnUri' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hirerAccounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'businessName' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hasConnectedTalentSearchAccess',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'loginRedirectUrl' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'input' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: {
                                          kind: 'Name',
                                          value: 'returnUri',
                                        },
                                        value: {
                                          kind: 'Variable',
                                          name: {
                                            kind: 'Name',
                                            value: 'returnUri',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetHirerAccountsQuery__
 *
 * To run a query within a React component, call `useGetHirerAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHirerAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHirerAccountsQuery({
 *   variables: {
 *      returnUri: // value for 'returnUri'
 *   },
 * });
 */
export function useGetHirerAccountsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetHirerAccountsQuery,
    GetHirerAccountsQueryVariables
  > &
    (
      | { variables: GetHirerAccountsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetHirerAccountsQuery, GetHirerAccountsQueryVariables>(
    GetHirerAccountsDocument,
    options,
  );
}
export function useGetHirerAccountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHirerAccountsQuery,
    GetHirerAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetHirerAccountsQuery,
    GetHirerAccountsQueryVariables
  >(GetHirerAccountsDocument, options);
}
export function useGetHirerAccountsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetHirerAccountsQuery,
        GetHirerAccountsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetHirerAccountsQuery,
    GetHirerAccountsQueryVariables
  >(GetHirerAccountsDocument, options);
}
export type GetHirerAccountsQueryHookResult = ReturnType<
  typeof useGetHirerAccountsQuery
>;
export type GetHirerAccountsLazyQueryHookResult = ReturnType<
  typeof useGetHirerAccountsLazyQuery
>;
export type GetHirerAccountsSuspenseQueryHookResult = ReturnType<
  typeof useGetHirerAccountsSuspenseQuery
>;
export type GetHirerAccountsQueryResult = Apollo.QueryResult<
  GetHirerAccountsQuery,
  GetHirerAccountsQueryVariables
>;
